import { render, staticRenderFns } from "./VendorProjectHistoryEdit.vue?vue&type=template&id=64ce7a70&"
import script from "./VendorProjectHistoryEdit.vue?vue&type=script&lang=js&"
export * from "./VendorProjectHistoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports